import { FC, memo } from "react";
import Typography from "@mui/material/Typography";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { Skeleton } from "../../../components/loading";
import { abbreviateNumber } from "../../../utils/numberUtils";

interface NumberCardProps {
  id: string;
  title: string;
  count: number;
  isLoading: boolean;
  skeletonWidth?: number;
}

export const NumberCard: FC<NumberCardProps> = memo(
  ({ id, title, count, isLoading, skeletonWidth }) => {
    return (
      <OutlinedPaper
        id={id}
        sx={{
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Typography variant="h4">{title}</Typography>
        <Skeleton
          isLoading={isLoading}
          height={30}
          width={skeletonWidth || 50}
          margin="3px 0 0 0"
        >
          <Typography variant="h2">{abbreviateNumber(count)}</Typography>
        </Skeleton>
      </OutlinedPaper>
    );
  }
);

NumberCard.displayName = "NumberCard";
